module.exports = __webpack_public_path__ + "static/media/madhuri.989da4a6.jpg";